import NDCListSection from './components/NDCListComponent';
import classes from './portfolio.module.scss';
import { useDrugPortfolio } from './useDrugPortfolio';
import NDCListLoader from './components/NDCListLoader';
import { observer } from 'mobx-react';

const DrugPortfolioManagement = () => {
  const {
    isActiveDrugsLoading,
    isDormantDrugsLoading,
    isInactiveDrugsLoading,
    activeDrugs,
    dormantDrugs,
    inactiveDrugs,
  } = useDrugPortfolio();

  return (
    <div className={classes.container}>
      {isActiveDrugsLoading || isDormantDrugsLoading || isInactiveDrugsLoading ? (
        <NDCListLoader />
      ) : (
        <NDCListSection heading="Active" ndcs={activeDrugs} from="Active" dest="Dormant" />
      )}

      {isActiveDrugsLoading || isDormantDrugsLoading || isInactiveDrugsLoading ? (
        <NDCListLoader />
      ) : (
        <NDCListSection heading="Dormant" ndcs={dormantDrugs} from="Dormant" dest="Active" />
      )}

      {isActiveDrugsLoading || isDormantDrugsLoading || isInactiveDrugsLoading ? (
        <NDCListLoader />
      ) : (
        <NDCListSection heading="Inactive" ndcs={inactiveDrugs} from="Inactive" dest="" />
      )}
    </div>
  );
};

export default observer(DrugPortfolioManagement);
